// Typelizer digest 1b6f971025af4ea3b22a2c82e8cbf2f3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/relief_listings/applications/:application_id/response */
  create: (
    params: { applicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/relief_listings/applications/:application_id/response', params, options),
    method: 'post',
  }),
}
